import { createI18n } from 'vue-i18n'
import zhCN from './lang/zh-cn'
import enUS from './lang/en-us'

var language = localStorage.getItem('locale') || window.navigator.language.toLowerCase() || 'zh-cn'
if (language.indexOf("zh-") !== -1) {
  language = 'zh-cn'
} else {
  language = 'en-us'
}
console.log('lang=', language)
localStorage.setItem('locale', language)

const i18n = createI18n({
  locale: language,
  messages: {
    'zh-cn': zhCN,
    'en-us': enUS
  }
})


export default i18n
